module.exports = __webpack_public_path__ + "img/luxura_v8.min.1212963b.svg";